module.exports = __webpack_public_path__ + "img/img_throw_2@2x.91cbd04a.png";